// extracted by mini-css-extract-plugin
export default {"shoppingCart":"WebsiteHeader_shoppingCart__PBk+S"};